import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CONTEXT_MENU_CLASS_NAME = 'ContextMenu';
export const CONTEXT_MENU_CLASS_SLOTS = ['root', 'list', 'wrapper'] as const;

export type ContextMenuClassSlot = (typeof CONTEXT_MENU_CLASS_SLOTS)[number];

export interface ContextMenuClasses {
	root: string;
	list: string;
	wrapper: string;
}

export type ContextMenuClassKey = keyof ContextMenuClasses;

export const getContextMenuUtilityClass = (slot: string) =>
	generateUtilityClass(CONTEXT_MENU_CLASS_NAME, slot as ContextMenuClassSlot);

export const contextMenuClasses: ContextMenuClasses = generateUtilityClasses(
	CONTEXT_MENU_CLASS_NAME,
	['root', 'list', 'wrapper'],
);

export default contextMenuClasses;
